import React, { useEffect, useState } from "react";
import styles from "./MonthPicker.module.css";
import "../global.css";

export function MonthPicker(props) {
  const [months, setMonths] = useState(
    props.selected && props.selected.length > 0
      ? props.selected
      : [
          {
            month: new Date().getMonth() + 1,
            year: new Date().getFullYear(),
            monthName: new Date().toLocaleString("en", { month: "short" }),
          },
        ]
  );
  const [year, setYear] = useState(
    props.selected && props.selected.length > 0
      ? props.selected[0].year
      : new Date().getFullYear()
  );

  useEffect(() => {
    const r = document.querySelector(":root");
    if (props.bgColorMonthActive) r.style.setProperty("--month-active-bg-color", props.bgColorMonthActive);
    if (props.bgColorMonthHover) r.style.setProperty("--month-hover-bg-color", props.bgColorMonthHover);
    if (props.borderRadiusMonth) r.style.setProperty("--month-border-radius", props.borderRadiusMonth);
    if (props.bgColorPicker) r.style.setProperty("--picker-bg-color", props.bgColorPicker);
    if (props.textColor) r.style.setProperty("--text-color", props.textColor);
    if (props.size === "small") {
      r.style.setProperty("--picker-padding", "1rem");
      r.style.setProperty("--year-display-margin-top", "0.5rem");
      r.style.setProperty("--year-display-margin-bottom", "0.5rem");
      r.style.setProperty("--month-select-padding", "0.5rem");
    }
  }, []);

  const getMonthNames = (locale = "en", format = "short") => {
    const formatter = new Intl.DateTimeFormat(locale, { month: format, timeZone: "UTC" });
    return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((month) => {
      const mm = month < 10 ? `0${month}` : month;
      return formatter.format(new Date(`2025-${mm}-01T00:00:00+00:00`));
    });
  };

  const changeMonth = (month) => {
    const _months = [
      {
        month,
        year,
        monthName: new Date(year, month - 1).toLocaleString("en", { month: "short" }),
      },
    ];
    setMonths(_months);
    props.onChange(_months);
    props.setIsOpen(false);
  };

  return (
    <div className={styles.pickerContainer}>
      <div className={styles.yearContainer}>
        <button type="button" className={styles.button} aria-label="Previous Year" onClick={() => setYear(year - 1)}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke={props.textColor ?? "#000"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="m15 18-6-6 6-6" />
          </svg>
        </button>
        <span className={styles.bold1}>{year}</span>
        <button type="button" className={styles.button} aria-label="Next Year" onClick={() => setYear(year + 1)}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke={props.textColor ?? "#000"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="m9 18 6-6-6-6" />
          </svg>
        </button>
      </div>
      <div className={styles.monthsContainer}>
        {getMonthNames().map((monthName, index) => (
          <button
            key={index}
            className={`${styles.month} ${styles.button} ${
              months.findIndex((m) => m.month === index + 1 && m.year === year) !== -1 ? styles.active : ""
            }`}
            onClick={() => changeMonth(index + 1)}
          >
            {monthName}
          </button>
        ))}
      </div>
    </div>
  );
}
